module.exports = __webpack_public_path__ + "img/building-06.f1251a81.webp";